import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { Enquiryheader } from 'src/app/model/enquiryheader.model';
import { NgForm, FormsModule } from '@angular/forms';
import { Enquiryline } from 'src/app/model/enquiryline.model';


@Component({
  selector: 'app-pricequote',
  templateUrl: './pricequote.component.html',
  styleUrls: ['./pricequote.component.css']
})
export class PricequoteComponent implements OnInit {

  stepno: string;
  enquiryData : any;
  enquiryHeader : Enquiryheader;

  data : Enquiryline[];

  constructor(private router: Router, private route: ActivatedRoute,
    private tenderingServices: TenderingService) {
      this.stepno = this.route.snapshot.params.enquiryid;
     }

  ngOnInit() {
    this.getEnquiryById();
  }

  getEnquiryById() {
    this.tenderingServices.GetEnquiryById(this.stepno).subscribe(
      datas => {
        this.enquiryData = datas;
        this.enquiryHeader = this.enquiryData;
        this.data = this.enquiryHeader.enquiryLine;

        console.log(this.data);
      }
    )
  }

  SubmitPriceQuoteForm(form: NgForm) {

    this.enquiryHeader.enquiryLine = this.data;
    this.enquiryHeader.quoteType = "price";
    this.enquiryHeader.id = 0;
    for(var i=0; i < this.enquiryHeader.enquiryLine.length; i++)
    {
      this.enquiryHeader.enquiryLine[i].quoteType = "price";
      this.enquiryHeader.enquiryLine[i].vendorNo = this.enquiryHeader.vendorNo;
      this.enquiryHeader.enquiryLine[i].id = 0;
    }

    //console.log(this.enquiryHeader);
    this.tenderingServices.InvitePriceQuote(this.enquiryHeader).subscribe(
      data => {
        alert("Successfully Submitted");
      }
    );

  }


}
